export class RiderData {
    unitSystem: number;
    shoeSizeSystem: number;

    customerAccountId: number;
    customerName: string;
    customerEmail: string;
    dateOfBirth: string;

    weight: number;
    height: number;
    soleLength: number;
    shoeSize: number;
    gender: string;
    skillLevel: number;

    city: string;
    phone: string;
    zipCode: string;
    country: string;
    street: string;
    houseNumber: string;
    state: string;
    passportId: string;
}